import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import type { GetPointCountResponse } from 'viewup-api/v2';

export const getEarnedPoints = async (): Promise<GetPointCountResponse> => {
  const response = await serviceApi.point.getPointCount(withServiceRequestDefaults());

  return response.data;
};
